<template>
    <main>
        <v-container class="grey lighten-4 fill-height" fluid>
                  <v-row class="flex">
            <v-container>
            <!-- <h1 class="">{{schedule.title}}</h1>
            <div class="mb-5"><v-icon>fa fa-map-marker-alt</v-icon> {{schedule.location}}</div>
            <div><v-icon>fa fa-quote-right</v-icon> {{schedule.description}}</div> -->
            <noifneeded v-bind:store="store" />
            </v-container>
            <!-- <v-container
                style="width:60%"
            >
                <noifneeded v-bind:store="store" />
            </v-container> -->
            <!-- <v-container style="width:60%" v-else>
                <ifneeded v-bind:store="store" />
            </v-container> -->
            <v-container style="width:20%">
                <adds :theme="schedule.theme" />
            </v-container>
        </v-row>  
        </v-container>
    </main>
</template>

<script>
import store from "../../store";
import noifneeded from "./participants/noifneeded";
// import ifneeded from "./participants/ifneeded";
import adds from "../ads";
export default {
    components: {
        noifneeded,
        // ifneeded,
        adds
    },
    data: function() {
        return {
            store: store,
            link: this.$route.params.link,
            schedule: null
        };
    },
    created: async function() {
        var bodyForm = new FormData();
        bodyForm.set("link", this.link);
        var config = {
            method: "post",
            url: "",
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            },
            data: bodyForm
        };
        await this.store.dispatch("getScheduleDetails", config);
        this.schedule = this.store.state.getSchedule.details[0];
    }
};
</script>

<style></style>
